import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { GTM_CONTAINER_ID } from '../../utils/constants';
import '../../types/gtm';
import { fireActiveOnSite } from '../../utils/dataLayer';

interface GoogleTagManagerProps {
  containerId?: string;
}

const GoogleTagManager: React.FC<GoogleTagManagerProps> = ({ 
  containerId = GTM_CONTAINER_ID 
}) => {
  useEffect(() => {
    // Initialize GTM dataLayer if it doesn't exist
    if (typeof window !== 'undefined' && !window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
    }
    
    // Fire active_on_site on initial page load
    if (typeof window !== 'undefined') {
      window.addEventListener('load', fireActiveOnSite);
      
      return () => {
        window.removeEventListener('load', fireActiveOnSite);
      };
    }
  }, []);

  // Don't render anything if no container ID is provided
  if (!containerId) {
    console.warn('GTM Container ID not provided. Google Tag Manager will not be loaded.');
    return null;
  }

  return (
    <Helmet>
      {/* GTM Head Script */}
      <script>
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${containerId}');
        `}
      </script>
    </Helmet>
  );
};

// Body script component - this needs to be rendered in the body
export const GoogleTagManagerBody: React.FC<GoogleTagManagerProps> = ({ 
  containerId = GTM_CONTAINER_ID 
}) => {
  // Don't render anything if no container ID is provided
  if (!containerId) {
    return null;
  }

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${containerId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      />
    </noscript>
  );
};

export default GoogleTagManager;
